import type { SerializableRecord } from '~~/lib/ContentfulTransformerService/model';
import { isSerializableRecord } from '~~/lib/ContentfulTransformerService/helper/isSerializableRecord';

export function getContentTypeId(value: SerializableRecord): unknown {
  const sys = isSerializableRecord(value.sys) ? value.sys : undefined;
  const contentType = isSerializableRecord(sys?.contentType)
    ? sys.contentType
    : undefined;
  const contentTypeSys = isSerializableRecord(contentType?.sys)
    ? contentType.sys
    : undefined;

  return contentTypeSys?.id;
}
